/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {useNavigate} from 'react-router-dom';
import {useEffect} from 'react';
import {NavigateFunction} from 'react-router';

interface Hooks {
	navigate?: NavigateFunction;
}

const OutHook: Hooks = {
	navigate: undefined
};

export const OutHookInitializer = () => {
	const _navigate = useNavigate();

	useEffect(() => {
		OutHook.navigate = _navigate;
	}, [_navigate]);

	return null;
};

export const navigate = (route: string) => {
	if (!OutHook.navigate) throw new Error('Navigate function not initialized');
	OutHook.navigate(route);
};
